var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"wrapper"},[(_vm.loadStatus && Object.keys(_vm.groupOrderDetails).length)?_c('div',{staticClass:"logo-band"},[_c('div',{staticClass:"redemption-logo"},[_c('img',{attrs:{"src":_vm.setLogo},on:{"error":_vm.handleBrokenImage}})])]):_vm._e(),_c('Notification'),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }